import { createApp } from "vue";
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import tr from "./locales/tr.json";
import de from "./locales/de.json";

import router from "./router";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import colors from "vuetify/lib/util/colors";
import { tr as vuetifyTr, en as vuetifyEn, de as vuetifyDe } from "vuetify/locale";
import "@mdi/font/css/materialdesignicons.css";
import "sweetalert2/src/sweetalert2.scss";
import "@/assets/global.css";
import responsiveTables from "@/plugins/responsiveTables";
import { createResponsiveDataTable } from "@/components/MainComponents/ResponsiveDataTable";
import BaseLayoutComp from "@/components/MainComponents/BaseLayoutComp";
const vuetify = createVuetify({
  locale: {
    locale: "tr",
    fallback: "en",
    messages: { tr: vuetifyTr, en: vuetifyEn, de: vuetifyDe },
  },
  components: {
    ...components,
    ...labsComponents,
    // Yatay kaydırmasız: sığmayan sütunlar satır altındaki "Detay" panelinde gösterilir
    VDataTable: createResponsiveDataTable(components.VDataTable, "VDataTable"),
    VDataTableServer: createResponsiveDataTable(
      components.VDataTableServer,
      "VDataTableServer",
    ),
  },
  directives,
  defaults: {
    // Telefonda (<600px) satırlar kart olarak gösterilir; tablet/masaüstünde sığmayan sütunlar Detay paneline alınır
    VDataTable: { mobile: null, mobileBreakpoint: "sm" },
    VDataTableServer: { mobile: null, mobileBreakpoint: "sm" },
    VDataTableVirtual: { mobile: null, mobileBreakpoint: "sm" },
    VCard: { rounded: "lg" },
    VBtn: { rounded: "lg" },
    VTextField: { density: "comfortable" },
    VSelect: { density: "comfortable" },
    VAutocomplete: { density: "comfortable" },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#1565c0",
          secondary: "#546e7a",
          info: "#0288d1",
          success: "#2e9e5b",
          warning: "#f59e0b",
          error: "#d64545",
          background: "#f4f7fb",
          surface: "#ffffff",
          greyLogin: colors.grey.lighten5,
        },
      },
    },
  },
});
import { createPinia } from "pinia";
import { useI18nStore } from "@/stores/i18nStore";
import piniaPersist from "pinia-plugin-persist";
const pinia = createPinia();
pinia.use(piniaPersist);
const i18nStore = useI18nStore(pinia);
vuetify.locale.current.value = i18nStore.locale; // Vuetify iç metinleri (Sırala, sayfa başına...) seçili dilde
const i18n = createI18n({
  locale: i18nStore.locale, // Store'dan alınan dil
  fallbackLocale: "en", // Yedek dil
  // globalInjection: true, // Enables this.$t in script block
  messages: {
    en,
    tr,
    de,
  },
});
const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(pinia);
app.use(i18n);
app.use(responsiveTables);
app.component("BaseLayoutComp", BaseLayoutComp);
app.mount("#app");
